import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";

import LogoRecial from '../Images/LogoRecial.jpg';

const MENU = [
  { path: "/dashboard",  label: "Dashboard",       icon: "📊" },
  { path: "/customers",  label: "Clientes",    icon: "👥" },
  { path: "/suppliers",  label: "Proveedores", icon: "🏭" },
  { divider: true, label: "OPERACIONES" },
  { path: "/receipts",   label: "Recogidas",   icon: "📥" },
  { path: "/entrances",  label: "Entradas",    icon: "📦" },
  { path: "/dispatches", label: "Salidas",     icon: "🚚" },
  { divider: true, label: "ACTIVOS" },
  { path: "/tanks",      label: "Depósitos",   icon: "🛢️" },
  { path: "/map",        label: "Logística",   icon: "🗺️" },
  { divider: true, label: "ANÁLISIS" },
  { label: "Histórico", path: "/historical", icon: "📚" },
];

const REPORTS_ITEMS = [
  { path: "/reports", label: "Balance Masas", icon: "⚖️" },
];

// Role badge colors
const ROLE_STYLES = {
  admin:   { bg: "rgba(220,38,38,0.2)",  color: "#fca5a5", label: "Administrador" },
  manager: { bg: "rgba(234,179,8,0.2)",  color: "#fde68a", label: "Manager" },
  driver:  { bg: "rgba(59,130,246,0.2)", color: "#93c5fd", label: "Conductor" },
};

function SideBar({ isActive }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [reportsOpen, setReportsOpen] = useState(
    location.pathname.startsWith("/reports")
  );
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const isActivePath = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const itemStyle = (active) => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "11px 14px",
    borderRadius: "9px",
    textDecoration: "none",
    marginBottom: "3px",
    fontSize: "15px",
    fontWeight: active ? "700" : "500",
    color: active ? "#ffffff" : "rgba(255,255,255,0.88)",
    background: active ? "rgba(255,255,255,0.2)" : "transparent",
    borderLeft: active ? "3px solid rgba(255,255,255,0.9)" : "3px solid transparent",
    transition: "all 0.15s ease",
    cursor: "pointer",
    width: "100%",
    textAlign: "left",
    border: "none",
    boxSizing: "border-box",
  });

  const hoverIn = (e, active) => {
    if (!active) {
      e.currentTarget.style.background = "rgba(255,255,255,0.1)";
      e.currentTarget.style.color = "#ffffff";
    }
  };

  const hoverOut = (e, active) => {
    if (!active) {
      e.currentTarget.style.background = "transparent";
      e.currentTarget.style.color = "rgba(255,255,255,0.88)";
    }
  };

  // Get initials from full name or username
  const initials = user?.full_name
    ? user.full_name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)
    : user?.username?.slice(0, 2).toUpperCase() || "?";

  const roleStyle = ROLE_STYLES[user?.role] || ROLE_STYLES.driver;

  return (
    <aside className={`sidebar ${isActive ? "is-active" : ""}`}>

      {/* Logo */}
      <div style={{ padding: "20px 16px 8px" }}>
        <Link to="/home" style={{ display: "block" }}>
          <img src={LogoRecial} alt="Recial"
            style={{ width: "100%", height: "80px", objectFit: "contain", display: "block" }} />
        </Link>
      </div>

      {/* Company name */}
      <div style={{ padding: "4px 20px 16px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
        <p style={{ fontSize: "12px", fontWeight: "700", color: "rgba(255,255,255,0.55)", letterSpacing: "0.08em", textTransform: "uppercase", margin: 0 }}>
          Reciclajes Recial
        </p>
        <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.35)", margin: "2px 0 0" }}>
          Sistema de Trazabilidad UCO
        </p>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: "12px 10px", overflowY: "auto" }}>

        {MENU.map((item, idx) => {
          if (item.divider) {
            return (
              <div key={idx} style={{ padding: "16px 10px 5px" }}>
                <p style={{ fontSize: "11px", fontWeight: "700", letterSpacing: "0.1em", color: "rgba(255,255,255,0.55)", textTransform: "uppercase", margin: 0 }}>
                  {item.label}
                </p>
              </div>
            );
          }

          const active = isActivePath(item.path);
          return (
            <Link key={item.path} to={item.path}
              style={itemStyle(active)}
              onMouseEnter={(e) => hoverIn(e, active)}
              onMouseLeave={(e) => hoverOut(e, active)}
            >
              <span style={{ fontSize: "18px", width: "22px", textAlign: "center", flexShrink: 0 }}>{item.icon}</span>
              <span style={{ flex: 1 }}>{item.label}</span>
              {active && <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "rgba(255,255,255,0.9)", flexShrink: 0 }} />}
            </Link>
          );
        })}

        {/* Reports — direct link */}
        {(() => {
          const active = isActivePath("/reports");
          return (
            <Link
              to="/reports"
              style={{
                ...itemStyle(active),
                borderLeft: active
                  ? "3px solid rgba(255,255,255,0.9)"
                  : "3px solid transparent",
              }}
              onMouseEnter={(e) => hoverIn(e, active)}
              onMouseLeave={(e) => hoverOut(e, active)}
            >
              <span style={{ fontSize: "18px", width: "22px", textAlign: "center", flexShrink: 0 }}>📈</span>
              <span style={{ flex: 1 }}>Informes</span>
              {active && <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "rgba(255,255,255,0.9)", flexShrink: 0 }} />}
            </Link>
          );
        })()}

        {/* Settings */}
        {(() => {
          const active = isActivePath("/settings");
          return (
            <Link to="/settings" style={{ ...itemStyle(active), marginTop: "8px", borderLeft: active ? "3px solid rgba(255,255,255,0.9)" : "3px solid transparent" }}
              onMouseEnter={(e) => hoverIn(e, active)}
              onMouseLeave={(e) => hoverOut(e, active)}>
              <span style={{ fontSize: "18px", width: "22px", textAlign: "center", flexShrink: 0 }}>⚙️</span>
              <span style={{ flex: 1 }}>Ajustes</span>
              {active && <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "rgba(255,255,255,0.9)", flexShrink: 0 }} />}
            </Link>
          );
        })()}
      </nav>

      {/* ── User footer ── */}
      <div style={{ padding: "12px 14px 16px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>

        {/* Logout confirmation */}
        {showLogoutConfirm ? (
          <div style={{
            background: "rgba(220,38,38,0.15)",
            border: "1px solid rgba(220,38,38,0.3)",
            borderRadius: "10px",
            padding: "12px",
            textAlign: "center",
          }}>
            <p style={{ fontSize: "12px", color: "rgba(255,255,255,0.8)", margin: "0 0 10px", fontWeight: "600" }}>
              ¿Cerrar sesión?
            </p>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                style={{
                  flex: 1, padding: "7px", borderRadius: "7px",
                  background: "rgba(255,255,255,0.1)", border: "none",
                  color: "rgba(255,255,255,0.8)", fontSize: "12px",
                  fontWeight: "600", cursor: "pointer",
                }}
              >
                Cancelar
              </button>
              <button
                onClick={handleLogout}
                style={{
                  flex: 1, padding: "7px", borderRadius: "7px",
                  background: "#dc2626", border: "none",
                  color: "#fff", fontSize: "12px",
                  fontWeight: "700", cursor: "pointer",
                }}
              >
                Cerrar Session
              </button>
            </div>
          </div>
        ) : (
          <div style={{
            display: "flex", alignItems: "center", gap: "10px",
            padding: "10px 12px", borderRadius: "10px",
            background: "rgba(255,255,255,0.07)",
            cursor: "pointer",
            transition: "background 0.15s",
          }}
            onMouseEnter={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.12)"}
            onMouseLeave={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.07)"}
          >
            {/* Avatar */}
            <div style={{
              width: "34px", height: "34px", borderRadius: "50%",
              background: "rgba(255,255,255,0.2)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: "13px", fontWeight: "800", color: "#fff", flexShrink: 0,
            }}>
              {initials}
            </div>

            {/* User info */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{
                fontSize: "13px", fontWeight: "700",
                color: "rgba(255,255,255,0.9)", margin: 0,
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
              }}>
                {user?.full_name || user?.username || "Usuario"}
              </p>
              <span style={{
                display: "inline-block",
                fontSize: "10px", fontWeight: "700",
                background: roleStyle.bg,
                color: roleStyle.color,
                padding: "1px 7px",
                borderRadius: "999px",
                marginTop: "2px",
                textTransform: "capitalize",
              }}>
                {roleStyle.label}
              </span>
            </div>

            {/* Logout button */}
            <button
              onClick={(e) => { e.stopPropagation(); setShowLogoutConfirm(true); }}
              title="Cerrar sesión"
              style={{
                background: "rgba(255,255,255,0.1)",
                border: "none",
                borderRadius: "6px",
                width: "28px", height: "28px",
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer",
                fontSize: "14px",
                flexShrink: 0,
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "rgba(220,38,38,0.3)"}
              onMouseLeave={(e) => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
            >
              ↪
            </button>
          </div>
        )}
      </div>

    </aside>
  );
}

export default SideBar;
